import React, { Component } from "react";

export default class Product extends Component {
  render() {
    const { product } = this.props;

    return (
      <li>
        <div className="product-box-inner">
          <h2 className="title">
            <a href={product.detail_link}>{product.name}</a>
          </h2>
          <div className="row">
            <div
              className="col-lg-6"
              dangerouslySetInnerHTML={{ __html: product.stars }}
            />
            <div className="col-md-6"></div>
          </div>
          <div className="image-container">
            <a className="image-box" href={product.detail_link}>
              <img alt={product.name} src={product.image_url} />
            </a>
          </div>
          <div className="prices-and-availability">
            <div className="prices">
              <div className="recommended-price invisible">
                {formatMoney(product.recommended_price)}
              </div>
              <strong className="current-price">
                {formatMoney(product.price)}
              </strong>
            </div>
            <div className="availability">
              <strong className="available-quantity">
                {product.quantity_in_stock_label}
              </strong>

              <div className="availability-state.in-stock">
                u vás doma {product.delivery_date}
              </div>
            </div>
          </div>

          <p className="param-summary">
            {product.reviews_count > 0 ? (
              <strong className="reviews-summary">
                {product.reviews_count} hodnocení
              </strong>
            ) : (
              ""
            )}
            {product.summary}
          </p>
          <div className="actions-without-hover">
            <a
              className="detail-link button button-primary"
              href={product.link}
            >
              Detail produktu
            </a>
          </div>
        </div>
      </li>
    );
  }
}
